export const API_ENDPOINTS = {
    MEDICALSERVICES: {
        GET_SERVICECATEGORY_BY_ID: "ServiceCategory/GetById",
        GET_SERVICE_CATEGORY_ITEM: "ServiceCategory/GetSubService",
        SEARCH_SERVICECATEGORY: "ServiceCategory/Search",
        SAVE_SERVICECATEGORY: "/ServiceCategory/Save",
        UPDATE_SERVICECATEGORY: "/ServiceCategory/Update",
        DELETE_SERVICECATEGORY: "ServiceCategory/Delete",
        EXPORT_SERVICECATEGORY: "ServiceCategory/Export",

        GET_SERVICECATEGORYITEM_BY_ID: "ServiceCategoryItem/GetById",
        SEARCH_SERVICECATEGORYITEM: "ServiceCategoryItem/Search",
        EXPORT_SERVICECATEGORYITEM: "ServiceCategoryItem/Export",
        SAVE_SERVICECATEGORYITEM: "/ServiceCategoryItem/Save",
        UPDATE_SERVICECATEGORYITEM: "/ServiceCategoryItem/Update",
        DELETE_SERVICECATEGORYITEM: "ServiceCategoryItem/Delete",
      
    // Add other  endpoints here
    
  },
 
  // Add other modules like EMPLOYEE, DEPARTMENT etc.
};

export const QUERY_KEYS = {
    MEDICALSERVICES: {
        SERVICECATEGORY: ["ServiceCategorySearch"], // UNIQUE IN OVER ALL APPLICATION
        SERVICECATEGORYITEMS: ["ServiceCategoryItemSearch"],
  },
  
};